/* eslint-disable */
import { useContext, useState } from 'react';
import { MainContext } from '../../../context/ApiContext';
import { Nav, NavbarForm } from './styles';
import { DateTime } from 'luxon';
import { Autocomplete } from '@material-ui/lab';
import { Box, Button, Grid, TextField, makeStyles } from '@material-ui/core';
import useSWR from 'swr';
import { fetcher } from '../../../service/SWRFetcher';
import useApp from '../../../hooks/useApp';
import filterStyles from '../../filterStyles';
import { useAuth } from '../../../hooks/useAuth';

const DatePeriodFilter = ({ setFilters }) => {
  const { partners, brokers } = useApp();
  const { user } = useAuth();

  const classes = filterStyles();

  const dateNow = DateTime.now().toISODate();
  const dateLastMonth = DateTime.now().plus({ months: -1 }).toISODate();

  const [partner, setPartner] = useState();

  const { data: technicalTeams } = useSWR(`/technical-team/for/filter`, fetcher, { revalidateOnFocus: false });

  const [dates, setDates] = useState({
    date_ini: dateLastMonth,
    date_end: dateNow,
  });

  const [brokerId, setBrokerId] = useState();
  const [technicalTeam, setTechnicalTeam] = useState();

  function handleSubmit(event) {
    event.preventDefault();
    const filters = {
      date_ini: dates.date_ini,
      date_end: dates.date_end,
      partner_id: partner?.map((partner) => ({ id: partner.id })) || [],
      broker_id: brokerId?.map((b) => ({ id: b.id })) || [],
      technical_teams: technicalTeam?.map((team) => team?.value) || [],
    };
    setFilters((f) => ({ ...f, ...filters }));
  }

  const clear = () => {
    setDates({
      date_ini: dateLastMonth,
      date_end: dateNow,
    });
    setBrokerId([]);
    setPartner([]);
    const filters = {
      date_ini: dates.date_ini,
      date_end: dates.date_end,
      partner_id: partner?.map((partner) => ({ id: partner.id })) || null,
      broker_id: brokerId?.map((b) => ({ id: b.id })) || null,
      technical_teams: technicalTeam?.map((team) => team?.value) || [],
    };
    setFilters((f) => ({ ...f, ...filters }));
  };

  const handleChangeDates = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setDates({
      ...dates,
      [name]: value,
    });
  };

  return (
    <Box className={classes.boxFilter}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_ini"
                placeholder="Data Inicial"
                value={dates.date_ini}
                onChange={handleChangeDates}
              />
            </Grid>

            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_end"
                placeholder="Data Final"
                value={dates.date_end}
                onChange={handleChangeDates}
              />
            </Grid>

            {[1, 2, 4].includes(user?.role) && (
              <>
                <Grid item xs={12} md={2}>
                  <Autocomplete
                    multiple
                    options={partners ? partners : []}
                    getOptionLabel={(option) => option?.name}
                    onChange={(e, value) => setPartner(value)}
                    className={classes.inputSelect}
                    renderInput={(params) => <TextField {...params} variant="standard" placeholder="Empresas" />}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Autocomplete
                    className={classes.inputSelect}
                    multiple
                    options={brokers || []}
                    getOptionLabel={(option) => option?.name}
                    onChange={(e, value) => setBrokerId(value)}
                    renderInput={(params) => (
                      <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Autocomplete
                    className={classes.inputSelect}
                    multiple
                    options={technicalTeams || []}
                    getOptionLabel={(option) => option?.name}
                    onChange={(e, value) => setTechnicalTeam(value)}
                    renderInput={(params) => (
                      <TextField {...params} className="autocomplete" variant="standard" placeholder="Equipes" />
                    )}
                  />
                </Grid>
              </>
            )}

            <Grid item>
              <Button fullWidth className={classes.button} type="submit">
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default DatePeriodFilter;
